import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getdetailstimesheetD = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}`}` + `/get/${id}`);
};

export const billing_expense_printInvTS = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/print_inv_ts/${id}`);
};

export const billing_expense_getaddtimesheetD = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/`, data);
};

export const billing_expense_getAllBytimesheet_hid = (data) => {
    return httpClient.post(
        `${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/detail_timesheet_hid`,
        data
    );
};
export const billing_expense_getAllBytimesheetCreeper_hid = (data) => {
    return httpClient.post(
        `${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/detail_timesheetCreeper_hid`,
        data
    );
};

export const billing_expense_getupdatetimesheetD = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/${id}`, data);
};

export const billing_expense_getdeletetimesheetD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/${id}`);
};

export const billing_expense_getdeletebyTSIdtimesheetD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.TIMESHEET_D_URL}` + `/timesheet_hid/${id}`);
};
